import BaseParagraph from "../baseComponents/baseParagraph.js";
import { useEffect, useRef } from "react";
import useColors from "../customHooks/useColors.js";

const Message = ({
  children,
  isError = true,
  translate = true,
  scrollToMessage = true,
  style = {},
  fadeIn = true,
}) => {
  const [currentColors] = useColors();

  const messageRef = useRef();

  const isVisible = children ?? "" != "";

  const styles = {
    message: {
      color: isError === true ? currentColors.octonary : currentColors.tertiary,
      visibility: isVisible ? "visible" : "hidden",
      opacity: isVisible ? 1 : 0, // Add opacity property
      transition: "opacity 0.15s linear", // Add transition property
      display: "block",
    },
  };

  useEffect(() => {
    if (isError === true && scrollToMessage === true) {
      messageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isError]);

  return (
    <BaseParagraph
      style={{ ...styles.message, ...style }}
      translate={translate}
      innerRef={messageRef}
      className={fadeIn && isVisible ? "fade-in" : "none"} // Add condition to add "fade-in" class only when element is visible
    >
      {isVisible ? children : " "}
    </BaseParagraph>
  );
};

export default Message;
